<template>
  <div class="admin-tab-content">
    <div class="tab-header">
      <h2>Noticias flash</h2>
      <p class="description">Controla quién puede ver la sección pública de noticias flash</p>
    </div>

    <div class="control-section">
      <label for="newsflash-access-mode">Visibilidad:</label>
      <select id="newsflash-access-mode" v-model="publicAccessEnabled" class="admin-select">
        <option :value="1">Visible para alumnos con rol activo</option>
        <option :value="0">Sólo administradores</option>
      </select>
      <p class="help-text">
        Gestión noticias flash seguirá siendo sólo para administradores. Este ajuste afecta al item Noticias flash del menú y a la lectura de noticias publicadas.
      </p>
    </div>

    <div class="action-section">
      <button type="button" class="btn-primary" :disabled="saving" @click="saveSettings">
        {{ saving ? 'Guardando...' : 'Guardar Configuración' }}
      </button>
    </div>

    <div v-if="message" :class="['message-box', messageType]">
      {{ message }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'NewsflashSettingsTab',
  data() {
    return {
      publicAccessEnabled: 1,
      saving: false,
      message: '',
      messageType: '',
    };
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    async loadSettings() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/newsflash-public-access-setting`);
        if (response.data.success) {
          this.publicAccessEnabled = parseInt(response.data.value);
        }
      }
      catch (error) {
        console.error('Error loading Newsflash settings:', error);
      }
    },
    async saveSettings() {
      this.saving = true;
      this.message = '';

      try {
        const response = await axios.get(`${process.env.VUE_APP_API}/adminmenu/newsflash-public-access-setting/${this.publicAccessEnabled}`);

        if (response.data.success) {
          this.message = 'Configuración guardada correctamente. Los cambios se aplicarán cuando los usuarios recarguen la página.';
          this.messageType = 'success';

          setTimeout(() => {
            this.message = '';
          }, 5000);
        }
        else {
          this.message = response.data.message || 'Error al guardar la configuración';
          this.messageType = 'error';
        }
      }
      catch (error) {
        this.message = 'Error al guardar la configuración';
        this.messageType = 'error';
      }
      finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.admin-tab-content {
  padding: 20px;
}

.tab-header h2 {
  color: #3498db;
  font-size: 24px;
  margin-bottom: 10px;
}

.description {
  color: #bbb;
  margin-bottom: 30px;
}

.control-section {
  margin-bottom: 20px;
}

.control-section label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #e6e6e6;
}

.admin-select {
  background-color: #333;
  border: 1px solid #444;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 0 10px;
  width: 100%;
  max-width: 360px;
}

.help-text {
  color: #aaa;
  font-size: 13px;
  line-height: 1.6;
  margin-top: 10px;
  max-width: 680px;
}

.action-section {
  margin-top: 20px;
}

.btn-primary {
  background: #3498db;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  transition: all 0.2s ease;
}

.btn-primary:hover:not(:disabled) {
  background: #2980b9;
  transform: translateY(-1px);
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.message-box {
  background-color: #333;
  border-radius: 4px;
  margin-top: 15px;
  padding: 10px;
  border-left: 3px solid #3498db;
}

.message-box.success {
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.message-box.error {
  border-left-color: #e74c3c;
  color: #e74c3c;
}
</style>
